import {merge} from "lodash";
import partnerMessages from "@i18n_messages_es"

export default merge({}, partnerMessages);